<template>
  <div id="branchBalanceReportNewPage">
    <order-receipt-popup
      :order="selectedOrder"
      :active="isOrderReceiptOpen"
      @update:active="isOrderReceiptOpen = $event"
    ></order-receipt-popup>
    <vs-popup
      class="holamundo branch-mood-ledger-popup"
      :title="detail.summary.branch ? detail.summary.branch.name + ' — Mood Hareket Dökümü' : 'Mood Hareket Dökümü'"
      :active.sync="isDetailOpen"
    >
      <div v-if="detail.summary.branch">
        <vs-row vs-type="flex" vs-w="12" class="mb-4">
          <vs-col vs-type="flex" vs-w="4" class="px-1">
            <div class="w-full p-3 rounded border text-center">
              <div class="text-xsmall text-muted uppercase">Bakiye</div>
              <div class="text-medium bold">{{ $toCurrency(detail.summary.balance) }}</div>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="px-1">
            <div class="w-full p-3 rounded border text-center">
              <div class="text-xsmall text-muted uppercase">Toplam Mood</div>
              <div class="text-medium bold text-success">
                {{ detail.summary.totalEarnedQuantity }} Adet / {{ $toCurrency(detail.summary.totalEarnedAmount) }}
              </div>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="px-1">
            <div class="w-full p-3 rounded border text-center">
              <div class="text-xsmall text-muted uppercase">Hediye Kullanım Maliyeti</div>
              <div class="text-medium bold text-danger">
                {{ detail.summary.totalRedeemedProductCount }} Ürün ({{ detail.summary.totalRedeemedQuantity }} Mood) / {{ $toCurrency(detail.summary.totalRedeemedAmount) }}
              </div>
            </div>
          </vs-col>
        </vs-row>

        <!-- Doğrulama: aşağıdaki hareket listesinin sebep bazlı toplamları, üstteki özet rakamlarıyla birebir eşleşmeli -->
        <vs-row vs-type="flex" vs-w="12" class="mb-4 text-xsmall text-muted">
          <vs-col vs-type="flex" vs-w="6" class="px-1">
            Kazanılan (Sipariş+Üyelik+Referans-İptal): {{ verifyEarned.quantity }} Adet / {{ $toCurrency(verifyEarned.amount) }}
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="px-1">
            Kullanılan Hediye (Kullanım-İade): {{ verifyRedeemed.quantity }} Adet / {{ $toCurrency(verifyRedeemed.amount) }}
          </vs-col>
        </vs-row>

        <vs-table :data="detail.items" max-items="1000000" v-model="selectedDetailRow">
          <template slot="thead">
            <vs-th style="width: 18%;">İşlem</vs-th>
            <vs-th style="width: 14%;">Müşteri</vs-th>
            <vs-th style="width: 11%;">Telefon</vs-th>
            <vs-th style="width: 7%;">Mood</vs-th>
            <vs-th style="width: 9%;">Maliyet</vs-th>
            <vs-th style="width: 9%;">Sipariş No</vs-th>
            <vs-th style="width: 14%;">Referans</vs-th>
            <vs-th style="width: 18%;">Tarih & Saat</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody style="text-align: center">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                :class="{ 'cursor-pointer': tr.orderId }"
                :title="tr.orderId ? 'Tıklayarak siparişi görüntüleyin' : ''"
              >
                <vs-td>
                  <vs-chip :color="rowColor(tr)" class="weight-600">{{ tr.reasonLabel }}</vs-chip>
                </vs-td>
                <vs-td>
                  <p class="text-small">{{ tr.customer && tr.customer.name ? tr.customer.name : 'İsim Belirtilmemiş' }}</p>
                </vs-td>
                <vs-td>
                  <p class="text-small font-mono">{{ tr.customer ? tr.customer.phone : '' }}</p>
                </vs-td>
                <vs-td>
                  <vs-chip :color="rowColor(tr)" class="weight-700">{{ tr.quantityFormatted }}</vs-chip>
                </vs-td>
                <vs-td>
                  <p class="text-small text-danger">
                    {{ tr.reasonLabel === 'Hediye Kullanımı' || tr.reasonLabel === 'Hediye İadesi' ? $toCurrency(tr.amount) : '' }}
                  </p>
                </vs-td>
                <vs-td><p class="font-mono text-small">{{ tr.orderId ? tr.orderId : '-' }}</p></vs-td>
                <vs-td>
                  <p class="text-small" v-if="tr.relatedCustomer">{{ tr.relatedCustomer.name || 'İsim Belirtilmemiş' }}</p>
                  <span v-else class="text-grey">-</span>
                </vs-td>
                <vs-td><p class="text-small">{{ tr.date }} {{ tr.time }}</p></vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-popup>
    <vs-table id="branchBalanceReportNew" ref="table" :data="balances" :max-items="itemsPerPage" v-model="selected">
      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between">
            <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
              <vx-tooltip text="Detaylı Filtereleme" position="top">
                <vs-button
                  @click="isFilterActive = !isFilterActive"
                  class="panel-action text-warning xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="pickicon"
                  icon="icon-pick-filter"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip text="Excel Export" position="top">
                <vs-button
                  @click="getExcel"
                  class="panel-action text-dark xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="feather"
                  icon="icon-download"
                ></vs-button>
              </vx-tooltip>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col vs-type="flex" class="w-auto" v-for="(chip, index) in filterChips" :key="index">
                  <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col, index)" v-show="chip.value != ''" closable>
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">{{ chip.name + " :" }}</span>
                      </vs-col>
                      <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                        <span class="weight-600 italic text-xsmaller text-primary">{{ chip.value }}</span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-3/12"><vs-button class="p-1 weight-600" color="primary" type="flat">Şube</vs-button></vs-th>
        <vs-th class="w-2/12"><vs-button class="p-1 weight-600" color="primary" type="flat">Bakiye</vs-button></vs-th>
        <vs-th class="w-3/12"><vs-button class="p-1 weight-600" color="primary" type="flat">Toplam Mood</vs-button></vs-th>
        <vs-th class="w-2/12"><vs-button class="p-1 weight-600" color="primary" type="flat">Hediye Kullanım Maliyeti</vs-button></vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="{ 'cursor-pointer': tr.hasAnyTransaction }"
            :title="tr.hasAnyTransaction ? 'Tıklayarak mood hareketlerini görüntüleyin' : ''"
          >
            <vs-td class="w-3/12"><p class="text-center">{{ tr.branch.name }}</p></vs-td>
            <vs-td class="w-2/12"><p class="text-center weight-600">{{ $toCurrency(tr.balance) }}</p></vs-td>
            <vs-td class="w-3/12">
              <p class="text-center">
                {{ tr.totalEarnedQuantity }} Adet / {{ $toCurrency(tr.totalEarnedAmount) }}
              </p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center">
                {{ tr.totalRedeemedProductCount }} Ürün ({{ tr.totalRedeemedQuantity }} Mood) / {{ $toCurrency(tr.totalRedeemedAmount) }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import GlobalFilter from "../../GlobalFilter";
import OrderReceiptPopup from "../../OrderReceiptPopup";
import { GetBranchBalancesNewReport, GetBranchBalancesNewExcel, GetBranchMoodLedgerDetail } from "@/api/Reports";
import { getOrderEntries } from "@/api/Cart";

export default {
  name: "BranchBalanceReportNew",
  components: {
    PaginationDefault,
    GlobalFilter,
    OrderReceiptPopup,
  },
  data() {
    return {
      balances: [],
      totalDataRow: 0,
      selected: "",
      isDetailOpen: false,
      detail: { summary: {}, items: [] },
      isOrderReceiptOpen: false,
      selectedOrder: {},
      selectedDetailRow: "",
      tableOptions: {},
      currentPage: 0,
      itemsPerPage: 10,
      isFilterActive: false,
      filterOptions: ["branchCode", "branch", "city", "state", "branchEmail", "branchPhoneNumber", "branchAddress"],
      filterOptionNames: ["Kod", "İsim", "Şehir", "İlçe", "Email", "Telefon", "Adres"],
      filterChips: [],
    };
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    verifyEarned() {
      return this.sumByReasonLabels(["Sipariş", "Yeni Üyelik", "Referans"], ["Sipariş İptali"]);
    },
    verifyRedeemed() {
      return this.sumByReasonLabels(["Hediye Kullanımı"], ["Hediye İadesi"]);
    },
  },
  methods: {
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branchCode: null,
        branch: null,
        city: null,
        state: null,
        branchEmail: null,
        branchPhoneNumber: null,
        branchAddress: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getExcel() {
      GetBranchBalancesNewExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Şube Bakiye Raporu " + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
            this.$vs.notify({ color: "success", title: "Başarılı", text: "Excel Export Başarılı !" });
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Excel Export İşlemi Başarısız !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata !", text: "Sunucu Bağlantı Hatası !" });
        });
    },
    getBranchBalances() {
      GetBranchBalancesNewReport(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.balances = res.data.items;
            this.totalDataRow = res.data.totalCount;
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Şube Bakiyeleri Yüklenemedi !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata !", text: "Sunucu Bağlantı Hatası !" });
        });
    },
    rowColor(tr) {
      if (tr.reasonLabel === "Hediye İadesi") return "warning";
      return tr.direction == 1 ? "danger" : "success";
    },
    loadBranchMoodLedgerDetail(branchId) {
      GetBranchMoodLedgerDetail(branchId)
        .then((res) => {
          if (res && res.status === 200) {
            this.detail = res.data;
            this.isDetailOpen = true;
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Mood Hareket Dökümü Yüklenemedi !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata !", text: "Sunucu Bağlantı Hatası !" });
        });
    },
    loadOrderEntries(row) {
      getOrderEntries(row.orderId)
        .then((res) => {
          if (res && res.status === 200) {
            this.$nextTick(() => {
              this.selectedOrder = res.data;
              this.isOrderReceiptOpen = true;
            });
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Sipariş Detayı Yüklenemedi !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata", text: "Sunucu Bağlantı Hatası" });
        });
    },
    sumByReasonLabels(positiveLabels, negativeLabels) {
      const items = this.detail.items || [];
      const quantity =
        items.filter((x) => positiveLabels.includes(x.reasonLabel)).reduce((acc, x) => acc + x.quantity, 0) -
        items.filter((x) => negativeLabels.includes(x.reasonLabel)).reduce((acc, x) => acc + x.quantity, 0);
      const amount =
        items.filter((x) => positiveLabels.includes(x.reasonLabel)).reduce((acc, x) => acc + x.amount, 0) -
        items.filter((x) => negativeLabels.includes(x.reasonLabel)).reduce((acc, x) => acc + x.amount, 0);
      return { quantity, amount };
    },
  },
  watch: {
    selected(val) {
      if (val && val.hasAnyTransaction && val.branch) {
        this.loadBranchMoodLedgerDetail(val.branch.id);
      }
      this.selected = "";
    },
    isDetailOpen(val) {
      if (!val) this.detail = { summary: {}, items: [] };
    },
    isOrderReceiptOpen(val) {
      if (!val) this.selectedOrder = {};
    },
    selectedDetailRow(val) {
      if (val && val.orderId) {
        this.loadOrderEntries(val);
      }
      this.selectedDetailRow = "";
    },
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getBranchBalances();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created() {
    this.clearFilter();
  },
};
</script>

<style>
.branch-mood-ledger-popup .vs-popup {
  width: 96vw !important;
  max-width: 96vw !important;
  height: 94vh !important;
  max-height: 94vh !important;
  margin: 3vh auto !important;
}
.branch-mood-ledger-popup .vs-popup--content {
  height: calc(94vh - 65px) !important;
  max-height: calc(94vh - 65px) !important;
  overflow-y: auto !important;
}
.branch-mood-ledger-popup table {
  width: 100% !important;
  table-layout: fixed !important;
}
.branch-mood-ledger-popup th {
  padding: 6px 4px !important;
  vertical-align: middle !important;
  text-align: center !important;
  white-space: nowrap !important;
}
.branch-mood-ledger-popup td {
  padding: 6px 4px !important;
  vertical-align: middle !important;
  text-align: center !important;
  word-break: break-word;
}
</style>
